import config from "../../../config/app";

type URLs = Record<string, string>;

const urls = config.externalUrl as URLs;

const paramsReplacer = (params: URLs) => (url: string, key: string) =>
  url.replace(new RegExp(`{${key}}`, "g"), params[key]);

const getExternalURL = (urlKey: string, params: URLs): string => {
  const rawUrl = urls[urlKey];

  return rawUrl ? Object.keys(params).reduce(paramsReplacer(params), rawUrl) : "";
};

export { getExternalURL };
